import { takeLatest, put, call, select } from 'redux-saga/effects';
import { ignorarTransaction } from '../service';
import {
  IGNORAR_TRANSACTION_CONCILIACAO,
  IGNORAR_TRANSACTION_CONCILIACAO_PENDING,
  IGNORAR_TRANSACTION_CONCILIACAO_SUCCESS,
  IGNORAR_TRANSACTION_CONCILIACAO_FAILURE,
  NEW_FILTER_CONCILIACAO_BANCARIA,
  BUSCAR_RESUMO_CONCILIACAO,
} from '@handler';
import { AlertSuccess, AlertError } from '@components/common/AlertToast';
// import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaConciliacaoIgnorar(action) {
  yield put({ type: IGNORAR_TRANSACTION_CONCILIACAO_PENDING });

  try {
    yield call(ignorarTransaction, action.id);
    // trackingEventCX('action', MODULE_ACTIONS_ENUM.IGNORAR_TRANSACTION_CONCILIACAO);

    yield put({ type: IGNORAR_TRANSACTION_CONCILIACAO_SUCCESS});

    // Recarregar dados da listagem após sucesso, preservando o filtro de tipo (entradas/saídas)
    const currentFilter = yield select(state => state.entities.conciliacaoBancariaReducer.filter);
    yield put({
      type: NEW_FILTER_CONCILIACAO_BANCARIA,
      newFilter: true, // Usar true para preservar tipoTransacao
      args: {
        ...currentFilter,
        page: currentFilter.page || 0 // Manter na mesma página se possível
      }
    });

    // Atualizar resumo da conciliação
    const contaBancoId = currentFilter.contaBanco?.id;
    if (contaBancoId) {
      yield put({
        type: BUSCAR_RESUMO_CONCILIACAO,
        contaBancoId
      });
    }

    AlertSuccess('Registro ignorado com sucesso!');
  } catch (error) {
    yield put({ type: IGNORAR_TRANSACTION_CONCILIACAO_FAILURE });
    AlertError('Falha ao ignorar o registro! Tente novamente...');
  }
}

export default function* watchConciliacaoIgnorarTransaction() {
  yield takeLatest(IGNORAR_TRANSACTION_CONCILIACAO, sagaConciliacaoIgnorar);
}
